import gql from 'graphql-tag';

export interface LocationStatus {
  id: number;
  customer_id: number;
  name: string;
  location_status_color: string;
  created_utc: string;
  created_by: string;
  updated_utc: string;
  updated_by: string;
  deleted_utc: string;
  deleted_by: string;
}

export const GET_LOCATION_STATUSES = gql`
  query GetLocationStatuses {
    locationStatuses {
      id
      customer_id
      name
      location_status_color
      created_utc
      created_by
      updated_utc
      updated_by
      deleted_utc
      deleted_by
    }
  }
`;